const avatars = [
  require("../assets/images/avatars/avatar1.jpg"),
  require("../assets/images/avatars/avatar2.jpg"),
  require("../assets/images/avatars/avatar3.jpg"),
  require("../assets/images/avatars/avatar4.jpg"),
  require("../assets/images/avatars/avatar5.jpg"),
  require("../assets/images/avatars/avatar6.jpg"),
  require("../assets/images/avatars/avatar7.avif"),
  require("../assets/images/avatars/avatar8.jpg"),
];

export const getRandomAvatar = (): string => {
  const randomIndex = Math.floor(Math.random() * avatars.length);
  return avatars[randomIndex];
};
